export default __webpack_public_path__ + "static/media/mt.55d78de7.svg";